import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showAllObjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllGroups: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllUsers: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllBbRepos: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllOpsgenieTeams: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllProjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllProjectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bitbucketRepositoriesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	groupsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	opsgenieTeamsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	objectsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	optionsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	usersLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectsLabelGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showAllObjects: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-objects',
		defaultMessage: 'Show all objects',
		description: 'Tooltip message for showing all objects. For example, Show all objects',
	},

	showAllGroups: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-groups',
		defaultMessage: 'Show all groups',
		description: 'Tooltip message for showing all values groups. For example, Show all groups',
	},
	showAllUsers: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-users',
		defaultMessage: 'Show all users',
		description: 'Tooltip message for showing all values users. For example, Show all users',
	},
	showAllOptions: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-options',
		defaultMessage: 'Show all options',
		description: 'Tooltip message for showing all values options. For example, Show all options',
	},
	showAllBbRepos: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-bb-repos',
		defaultMessage: 'Show all Bitbucket repositories',
		description:
			'Tooltip message for showing all values Bitbucket repositories. For example, Show all Bitbucket repositories',
	},

	showAllItems: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-items',
		defaultMessage: 'Show all items',
		description: 'Tooltip message for showing all values items. For example, Show all items',
	},

	showAllOpsgenieTeams: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-opsgenie-teams',
		defaultMessage: 'Show all Opsgenie teams',
		description:
			'Tooltip message for showing all values Opsgenie teams. For example, Show all Opsgenie teams',
	},
	showAllProjects: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-projects',
		defaultMessage: 'Show all projects',
		description: 'Tooltip message for showing all values projects. For example, Show all projects',
	},
	showAllProjectsGalaxia: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.show-all-projects-galaxia',
		defaultMessage: 'Show all spaces',
		description: 'Tooltip message for showing all values spaces. For example, Show all spaces',
	},
	bitbucketRepositoriesLabel: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.bitbucket-repositories-label',
		defaultMessage: 'Bitbucket repositories',
		description:
			'Label for button that shows how many bitbucket repositories there are. For example, Bitbucket repositories 21',
	},
	groupsLabel: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.groups-label',
		defaultMessage: 'Groups',
		description: 'Label for button that shows how many groups there are. For example, Groups 21',
	},
	opsgenieTeamsLabel: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.opsgenie-teams-label',
		defaultMessage: 'Opsgenie teams',
		description:
			'Label for button that shows how many Opsgenie teams there are. For example, Opsgenie teams 21',
	},
	objectsLabel: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.objects-label',
		defaultMessage: 'Objects',
		description: 'Label for button that shows how many objects there are. For example, Objects 21',
	},

	optionsLabel: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.options-label',
		defaultMessage: 'Options',
		description: 'Label for button that shows how many options there are. For example, Options 21',
	},
	usersLabel: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.users-label',
		defaultMessage: 'Users',
		description: 'Label for button that shows how many users there are. For example, Users 21',
	},
	defaultLabel: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.default-label',
		defaultMessage: 'Items',
		description: 'Label for button that shows how many items there are. For example, Items 21',
	},
	projectsLabel: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.projects-label',
		defaultMessage: 'Projects',
		description:
			'Label for button that shows how many projects there are. For example, Projects 21',
	},
	projectsLabelGalaxia: {
		id: 'servicedesk-insight-shared-ui.multi-value-lozenge.projects-label-galaxia',
		defaultMessage: 'Spaces',
		description: 'Label for button that shows how many spaces there are. For example, Spaces 21',
	},
});
export default messages;
